import { FC, useEffect, useState } from 'react'
import { SectionQuoteWithVideoProps } from '@portfolio/models'
import { styled, useMediaQuery } from '@portfolio/styles'
import { InView } from 'react-intersection-observer'
import { VideoTestimonial } from '../SectionVideoTestimonials/VideoTestimonial'
import { SectionWrapper } from '@portfolio/components'

const StyledSectionWrapper = styled(SectionWrapper, {
  gap: '$32',
  display: 'grid',
  '@xl': {
    gridTemplateColumns: '340px 1fr',
  },
  borderRadius: '$r3_mobile',
  '@lg': {
    borderRadius: '$r3',
  },
})

const Quote = styled('p', {
  projectFont: 'heading06',
  marginTop: 0,
})

export const SectionQuoteWithVideo: FC<SectionQuoteWithVideoProps> = ({
  quote,
  media,
  personName,
  personPosition,
  logo,
  textColor,
  backgroundColor,
  priority,
}) => {
  const isMd = useMediaQuery('md')

  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  useEffect(() => {
    // when the view shifts between mobile and desktop, we want to pause videos to prevent double play
    setIsVideoPlaying(false)
  }, [isMd])

  const handleSlidePlayPause = () =>
    setIsVideoPlaying((prevState) => !prevState)

  const handleOnEnded = () => {
    setIsVideoPlaying(false)
  }

  const handleSlideIntersectionChange = (inView: boolean) => {
    if (!inView) {
      setIsVideoPlaying(false)
    }
  }

  const resolvedTextColor = textColor?.rgba || textColor?.hex
  const resolvedBackgroundColor = backgroundColor?.rgba || backgroundColor?.hex

  return (
    <StyledSectionWrapper
      type="RICH_TEXT_SM"
      css={
        resolvedBackgroundColor
          ? {
              backgroundColor: resolvedBackgroundColor,
            }
          : undefined
      }
    >
      <InView threshold={0.6} onChange={handleSlideIntersectionChange}>
        {({ inView, ref }) => (
          <VideoTestimonial
            ref={ref}
            media={media}
            personName={personName}
            personPosition={personPosition}
            logo={logo}
            priority={priority}
            play={isVideoPlaying}
            canHideControlsForVideo={isVideoPlaying}
            inView={inView}
            handleOnEnded={handleOnEnded}
            handleSlidePlayPause={handleSlidePlayPause}
          />
        )}
      </InView>

      {quote && (
        <div>
          <Quote
            css={
              resolvedTextColor
                ? {
                    color: resolvedTextColor,
                  }
                : undefined
            }
          >
            {quote}
          </Quote>
        </div>
      )}
    </StyledSectionWrapper>
  )
}
